import { FirstTimeUserPage } from "./component";

export default FirstTimeUserPage;
